import { Checkbox } from 'antd/lib'
import { useMemo, useState } from 'react'
import classes from './MarkdownViewer.module.less'
import MarkdownRenderer from 'Components/common/MarkdownRenderer/MarkdownRenderer'

type MarkdownViewerProps = {
    title: string
    text: string
    isTextStillGenerating?: boolean
}

export const MarkdownViewer = (props: MarkdownViewerProps) => {
    const [isMarkdownEnabled, setIsMarkdownEnabled] = useState(true)

    const previewResponse = useMemo(() => {
        const responseValue = props.text.replace(/(?<!\n\n)## Step/g, '\n\n ## Step')
        if (isMarkdownEnabled) {
            return <MarkdownRenderer children={responseValue} escapeBackslashses={true} />
        } else {
            return <div className={classes.plainText}>{responseValue}</div>
        }
    }, [isMarkdownEnabled, props.text])

    return (
        <div>
            <div className={classes.header}>
                <p className={classes.title}>{props.title}</p>
                <Checkbox
                    checked={isMarkdownEnabled}
                    onChange={e => setIsMarkdownEnabled(e.target.checked)}
                    className={classes.checkbox}
                >
                    Enable Markdown
                </Checkbox>
            </div>
            <div className={classes.previewResponse}>
                {previewResponse}
                {props.isTextStillGenerating && <span className={classes.blinkingCursor}></span>}
            </div>
        </div>
    )
}
